// parseDuration: converts seconds to human-readable duration string
export function parseDuration(s) {
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;

    let duration = "";

    if (hours > 0) {
        duration += `${hours} hour`;
        if (hours > 1) duration += "s";
    }

    if (minutes > 0) {
        if (duration.length > 0) duration += " and ";
        duration += `${minutes} minute`;
        if (minutes > 1) duration += "s";
    }

    if (seconds > 0) {
        if (duration.length > 0) duration += " and ";
        duration += `${seconds} second`;
        if (seconds > 1) duration += "s";
    }

    return duration;
}

// formatDateTime: smart date formatting (Today, Tomorrow, or full date)
export function formatDateTime(date) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const isToday = date.toDateString() === today.toDateString();
    const isTomorrow = date.toDateString() === tomorrow.toDateString();

    const timeString = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    if (isToday) {
        return `Today ${timeString}`;
    } else if (isTomorrow) {
        return `Tomorrow ${timeString}`;
    } else {
        const dateString = date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
        });
        return `${dateString} ${timeString}`;
    }
}

// calculateStartTime: calculates step start time from end time and duration
export function calculateStartTime(endTime, timeUntilEndSeconds) {
    const startTime = new Date(endTime);
    const timeUntilEndMinutes = timeUntilEndSeconds / 60;
    startTime.setMinutes(startTime.getMinutes() - timeUntilEndMinutes);
    return startTime;
}

// roundToNearestFiveMinutes: rounds a date to the nearest 5-minute interval
export function roundToNearestFiveMinutes(date) {
    const minutes = date.getMinutes();
    const roundedMinutes = Math.round(minutes / 5) * 5;
    const roundedDate = new Date(date);
    roundedDate.setMinutes(roundedMinutes, 0, 0);
    return roundedDate;
}

// getTodayDateString: returns today's date as YYYY-MM-DD
export function getTodayDateString() {
    const now = new Date();
    return now.toISOString().split('T')[0];
}

// formatTime: formats seconds into a human-readable countdown string
export function formatTime(seconds) {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (days > 0) {
        return `${days}d ${hours}h ${mins}m`;
    } else if (hours > 0) {
        return `${hours}h ${mins}m ${secs}s`;
    } else {
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
}
